'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { motion } from 'framer-motion';
import type { ChatMessageData } from '../../_utils/message';
import { AiMessage } from './AiMessage';
import { UserMessage } from './UserMessage';
interface ChatMessageProps {
  message: ChatMessageData;
  isLatest?: boolean;
  withBottomSpacer?: boolean;
  onSelectOption?: (value: string) => void;
}
export const ChatMessage = t0 => {
  const $ = _c(19);
  const {
    message,
    isLatest,
    withBottomSpacer: t1,
    onSelectOption
  } = t0;
  const withBottomSpacer = t1 === undefined ? isLatest : t1;
  const isUser = message.type === "user";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 1
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = isUser ? "justify-end" : "justify-start";
  let t4;
  if ($[1] !== t3) {
    t4 = cn("flex w-full gap-10", t3);
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `message-${message.id}`;
  let t6;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0
    };
    t7 = {
      duration: 0.2,
      ease: "easeOut"
    };
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  let t8;
  if ($[5] !== isLatest || $[6] !== isUser || $[7] !== message || $[8] !== onSelectOption) {
    t8 = isUser ? <UserMessage message={message} /> : <AiMessage isLatest={isLatest} message={message} onSelectOption={onSelectOption} />;
    $[5] = isLatest;
    $[6] = isUser;
    $[7] = message;
    $[8] = onSelectOption;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t8) {
    t9 = <motion.div animate={t2} className={t4} id={t5} initial={t6} transition={t7}>{t8}</motion.div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== withBottomSpacer) {
    t10 = withBottomSpacer && <div style={{
      height: "var(--wello-agent-composer-h, 160px)"
    }} />;
    $[14] = withBottomSpacer;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};